<ion-app [class.ion-palette-dark]="dark">
    @if (!authService.isInitialized()) {
      <ion-spinner name="crescent" />
    } @else if (authService.isLoggedIn()) {
      <ion-router-outlet id="main-content"></ion-router-outlet>
    } @else {
      <ion-nav [root]="loginComponent"></ion-nav>
    }
    <ion-alert
        [isOpen]="isPushNotificationPermissionAlertOpen()"
        header="Push obavijesti"
        message="Nakon što zatvorite ovu poruku će vam se prikazati zahtjev za dopuštenje primanja push obavijesti, molim vas da prihvatite da bi mogli koristiti ovu functionalost."
        [buttons]="['Ok']"
        (didDismiss)="onPushNotificationPermissionAlertDismiss()">
    </ion-alert>
    <ion-alert
        [isOpen]="canInstallAndroid()"
        header="Instalacija aplikacije"
        message="Molim vas da instalirate aplikaciju kako biste mogli koristiti sve funkcionalnosti."
        [buttons]="['Instaliraj']"
        (didDismiss)="onInstallAndroid()">
    </ion-alert>
</ion-app>
